import { useMutation } from '@tanstack/react-query';
import deleteCertificates, {
  DeleteCertificatesParams,
} from '~apis/certificates/deleteCertificates';
import { queryClient } from '~libs/queryClient';

import { USE_GET_CERTIFICATES_QUERY } from './useCertificatesQuery';
import { USE_DATA_QUALIFICATIONS_QUERY } from './useDataQualificationsQuery';

export default function useDeleteCertificationsMutation() {
  return useMutation(
    ({ companyId, certificateId }: DeleteCertificatesParams) =>
      deleteCertificates({ companyId, certificateId }),
    {
      onSuccess: (_, variables) => {
        const companyId = variables.companyId;
        queryClient.invalidateQueries(USE_GET_CERTIFICATES_QUERY.default(companyId));
        queryClient.invalidateQueries(USE_DATA_QUALIFICATIONS_QUERY.default(variables.companyId));
      },
    },
  );
}
